
export default {
  props: {
    id: {
      default: '',
      type: String,
    },
    classes: {
      default: '',
      type: String
    }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },

}
